import {
  MutationFunction,
  useMutation,
  useQuery,
  useQueryClient
} from "react-query";
import {
  createEventMaterial,
  deleteEventMaterial,
  getEventMaterials,
  updateEventMaterial
} from "../../../services/api/eventMaterials";
import { EventMaterial, Options, QueryListResult } from "../utils/types";
import { EVENT_MATERIALS_QUERY_KEY } from "./useEventMaterials";

export const useCreateEventMaterial = (eventId: number, materialId: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ data }: { data: any }) => {
      return createEventMaterial(eventId, { materialId, ...data });
    },
    {
      onError: (error, variables, context) => {
        console.error("ERROR ERROR ERROR", error);
        // An error happened!
        // console.log(`rolling back optimistic update with id ${context.id}`)
      },

      onSuccess: (data, variables, context) => {
        // Boom baby!
        queryClient.invalidateQueries(EVENT_MATERIALS_QUERY_KEY);
      }
    }
  );
};
